import { SUBSCRIPTIONS } from '@/clients'
import { laravelErrorHandler } from '@/helpers'
import { buildCartPayload } from '@/helpers/cartPayload'

const mapCartPayloadToParams = cartPayload => {
  const params = {}
  if (!cartPayload) {
    return params
  }

  const toBooleanParam = value => {
    if (value === true) {
      return 1
    }
    if (value === false) {
      return 0
    }
    return value
  }

  const appendPlan = (plan, index) => {
    params[`plans[${index}][code]`] = plan.code
    params[`plans[${index}][trial]`] = toBooleanParam(plan.trial)
    if (plan.add_ons && plan.add_ons.length) {
      plan.add_ons.forEach((addOn, addOnIndex) => {
        params[`plans[${index}][add_ons][${addOnIndex}]`] = addOn
      })
    }
  }

  const appendItem = (item, index) => {
    params[`items[${index}][code]`] = item.code
    if (item.quantity) {
      params[`items[${index}][quantity]`] = item.quantity
    }
  }

  cartPayload.plans?.forEach(appendPlan)
  cartPayload.items?.forEach(appendItem)

  if (cartPayload.bundle) {
    if (cartPayload.bundle.slug) {
      params['bundle[slug]'] = cartPayload.bundle.slug
    }
    if (cartPayload.bundle.voucher) {
      params['bundle[voucher]'] = cartPayload.bundle.voucher
    }
    if (cartPayload.bundle.skill_dive_area) {
      params['bundle[skill_dive_area]'] = cartPayload.bundle.skill_dive_area
    }
  }

  return params
}

const fetchCouponInfo = async (couponStr, cartPayloadParams = {}) => {
  const route = `coupon`
  try {
    const params = { code: couponStr, ...cartPayloadParams }
    const {
      data: { data },
    } = await SUBSCRIPTIONS.get(route, { params })
    return data
  } catch (error) {
    throw laravelErrorHandler(error)
  }
}

const fetchCouponInfoWithCart = (couponStr, cartContext) => {
  const cartPayload = buildCartPayload(cartContext)
  const params = mapCartPayloadToParams(cartPayload)
  return fetchCouponInfo(couponStr, params)
}

export { fetchCouponInfo, fetchCouponInfoWithCart, mapCartPayloadToParams }
